import Box from '@zenbusiness/zui/Box';
import Grid from '@zenbusiness/zui/Grid';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import useBreakpoints from '#client/hooks/useBreakpoints';

import PageWrapper from './PageWrapper';
import { TermsTriptychStyled } from './TermsTriptych.styles';

export default function TermsTriptych() {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  return (
    <TermsTriptychStyled
      marginTop={{ xs: '30%', md: '8%' }}
      paddingY={{ xs: '40px', md: '120px' }}
    >
      <Box marginX={{ xs: '16px', md: '5.5%' }}>
        <PageWrapper>
          <Grid container>
            <Grid
              item
              md={6}
              xs={12}
            >
              <Stack
                alignItems="center"
                flexDirection={{ xs: 'row', md: 'column' }}
                gap={{ xs: '12px', md: '20px' }}
                paddingX={{ xs: 0, md: '98px' }}
              >
                <Box>
                  <SharedAsset
                    alt=""
                    height={isDesktop ? 184 : 80}
                    src="/s2/vector/keeps-you-protected-bank.svg"
                    width={isDesktop ? 184 : 80}
                  />
                </Box>
                <Stack spacing="8px">
                  <Text
                    align={isDesktop ? 'center' : 'left'}
                    color="primary"
                    size="xl"
                    weight="medium"
                  >
                    Keeps you protected
                  </Text>
                  <Text
                    align={isDesktop ? 'center' : 'left'}
                    color="primary"
                    size="md"
                  >
                    An LLC protects personal assets. A bank account helps ensure that protection.
                  </Text>
                </Stack>
              </Stack>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <Stack
                alignItems="center"
                flexDirection={{ xs: 'row', md: 'column' }}
                gap={{ xs: '12px', md: '20px' }}
                paddingX={{ xs: 0, md: '98px' }}
              >
                <Box>
                  <SharedAsset
                    alt=""
                    height={isDesktop ? 184 : 80}
                    src="/s2/vector/separates-your-finances-bank.svg"
                    width={isDesktop ? 184 : 80}
                  />
                </Box>
                <Stack spacing="8px">
                  <Text
                    align={isDesktop ? 'center' : 'left'}
                    color="primary"
                    size="xl"
                    weight="medium"
                  >
                    Separates your finances
                  </Text>
                  <Text
                    align={isDesktop ? 'center' : 'left'}
                    color="primary"
                    size="md"
                  >
                    Keep track of the money flowing in and out of your business.
                  </Text>
                </Stack>
              </Stack>
            </Grid>
            <Stack />
          </Grid>
        </PageWrapper>
      </Box>
    </TermsTriptychStyled>
  );
}
